import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITrainingTemplateResource } from "../types";

export interface ITrainingTemplateDuplicateMutationParameters {
    trainingTemplate: RelationalValue<ITrainingTemplateResource>;
}

export type ITrainingTemplateDuplicateMutationResult = ITrainingTemplateResource;

export const trainingTemplateDuplicateMutation: IApiMutationFunction<ITrainingTemplateDuplicateMutationParameters> = ({
    trainingTemplate,
}) => {
    return {
        method: "POST",
        url: `/training_templates/${mapRelationalValue(trainingTemplate)}/duplicate`,
        data: {},
    };
};

export const useTrainingTemplateDuplicateMutation = createApiMutationHook<
    ITrainingTemplateDuplicateMutationParameters,
    ITrainingTemplateDuplicateMutationResult
>(trainingTemplateDuplicateMutation);
